module.exports = __webpack_public_path__ + "img/mbtishi.1b36796b.svg";